import { ConfigProvider, Tree, Typography } from 'antd'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { DataNode } from 'antd/lib/tree'
import { utilsEditor } from '@amaspace-editor/editor-3d'
import styled from 'styled-components'

type TAssetEditorTree = {
    nodes: DataNode[]
    onSelect: (selectedKeys: React.Key[], info: any) => void
    defaultExpandedKeys?: string[]
    selectedKeys?: string[]
    draggable?: boolean
}

const AssetEditorTree: React.FC<TAssetEditorTree> = ({
    nodes,
    defaultExpandedKeys,
    onSelect,
    selectedKeys,
    draggable = false
}) => {
    const editor3d = utilsEditor()
    const treeState = useMemo(() => {
        return nodes
    }, [nodes])
    const [selectedKey, setSelectedKey] = useState(selectedKeys)
    const getAllKeys = useCallback((data: DataNode[]): any[] => {
        const nestedKeys = data.map(node => {
            let childKeys = []
            if (node.children) {
                childKeys = getAllKeys(node.children)
            }
            return [childKeys, node.key]
        })
        return nestedKeys.flat(Infinity)
    }, [])
    const [allKeys, setAllKeys] = useState<any[]>(getAllKeys(nodes))

    useEffect(() => {
        setAllKeys(getAllKeys(nodes))
    }, [getAllKeys, nodes])

    const selectedMesh = useCallback(
        (children: DataNode): string | number | undefined => {
            //@ts-ignore
            if (children.id === editor3d.activeMesh?.userData.id) {
                if (typeof children.key === 'string') {
                    setSelectedKey([children.key])
                }
                return children.key as string
            }

            if (!children?.children) return

            for (const item of children.children) {
                const result = selectedMesh(item)
                if (result !== undefined) {
                    return result
                }
            }
            return undefined
        },
        [editor3d.activeMesh?.userData.id]
    )

    useEffect(() => {
        if (editor3d.activeMesh) {
            treeState.map(item => selectedMesh(item))
        }
        return () => {
            setSelectedKey([''])
        }
    }, [editor3d.activeMesh, selectedMesh, treeState])

    return (
        <>
            <Typography.Title level={3}>Nodes</Typography.Title>

            <Tree
                defaultExpandAll={true}
                draggable={draggable}
                expandedKeys={allKeys}
                onExpand={expandedKeys => {
                    setAllKeys(expandedKeys)
                }}
                onSelect={onSelect}
                selectedKeys={selectedKey}
                showLine={true}
                showIcon={true}
                treeData={nodes}
            />
        </>
    )
}

export default AssetEditorTree
